﻿var CookieConsentService = {
    CookieConsentKey: "",
    EnableImpliedCookieConsent: false,
    didConsentToAllCookies: function () {
        //Logic shared with MvcExtensions.DidConsentToCookie
        //Please keep in sync
        
        if (this.CookieConsentKey === "") {
            //console.log("Cookie consent key was not set");
            return false;
        }

        var cookieSettings = this.getCookieSettings();

        var didConsent = cookieSettings.didConsentToAllManually ||
            (this.EnableImpliedCookieConsent && cookieSettings.didConsentImplicitly && !cookieSettings.didConsentToEssentialManually);
        return didConsent;
    },
    shouldShowCookieBanner: function () {
        var cookieSettings = this.getCookieSettings();

        return (this.EnableImpliedCookieConsent && cookieSettings.shouldShowImpliedCookieBanner) ||
            (!this.EnableImpliedCookieConsent && cookieSettings.shouldShowCookieBanner);
    },
    clearAllCookiesIfConsentNotGiven: function () {
        //Clearing all cookies but consent cookie and essential cookies
        var cookieSettings = this.getCookieSettings();

        if (!this.didConsentToAllCookies()) {
            var cookies = document.cookie.split(";");
            for (var cookie in cookies) {
                if (cookie !== this.CookieConsentKey && cookieSettings.essentialCookies.indexOf(cookie) == -1) {
                    deleteCookie(cookie);
                }
            }
        }
    },
    getCookieSettings: function () {
        //Logic shared with MvcExtensions.DidConsentToCookie
        //Please keep in sync
        var result = {
            didConsentImplicitly: this.EnableImpliedCookieConsent,
            didConsentToAllManually: false,
            didConsentToEssentialManually: false,
            shouldShowCookieBanner: true,
            shouldShowImpliedCookieBanner: true,
            essentialCookies: ["pdt", "GAK_ShoppinBasket", "GAK_CookieConsent", "GAK_SearchRef",
                "GAK_VoucherPromoPopup", "LocationId", "ChannelID", "__RequestVerificationToken",
                "GAK_FinanceOptions", "amazon-pay-connectedAuth", "apay-session-set",
                "GAK_FE_Email", ".AspNet.ApplicationCookie"]
        };

        ///Returning boolValue if it's a bool, fallbackBool otherwise
        function getSafeBool(boolValue, fallbackBool) {
            if (typeof (boolValue) === "boolean") {
                return boolValue;
            }

            return fallbackBool;
        }

        try {
            var consentCookie = unescape(getCookie(this.CookieConsentKey));
            var cookieObj = JSON.parse(consentCookie);

            if (cookieObj === true) {
                result.didConsentImplicitly = true;
                result.didConsentToAllManually = false;
                result.didConsentToEssentialManually = true;
                result.shouldShowCookieBanner = false;
                result.shouldShowImpliedCookieBanner = false;
            }
            else if (cookieObj != null && typeof (cookieObj) === "object") {
                result.didConsentImplicitly = getSafeBool(cookieObj.didConsentImplicitly, result.didConsentImplicitly);
                result.didConsentToAllManually = getSafeBool(cookieObj.didConsentToAllManually, result.didConsentToAllManually);
                result.didConsentToEssentialManually = getSafeBool(cookieObj.didConsentToEssentialManually, result.didConsentToEssentialManually);
                result.shouldShowCookieBanner = getSafeBool(cookieObj.shouldShowCookieBanner, result.shouldShowCookieBanner);
                result.shouldShowImpliedCookieBanner = getSafeBool(cookieObj.shouldShowImpliedCookieBanner, result.shouldShowImpliedCookieBanner);
            }

        } catch (e) {
            //In case of exception assume cookie doesn't exist
            //Nothing to do
        }

        return result;
    },
    onManuallyConsentToAllCookies: function () {
        var settings = CookieConsentService.getCookieSettings();
        settings.didConsentToAllManually = true;
        settings.didConsentImplicitly = true;
        settings.shouldShowCookieBanner = false;
        settings.shouldShowImpliedCookieBanner = false;

        CookieConsentService.saveCookieConsent(settings);
    },
    onManuallyConsentToEssentialCookies: function () {
        var settings = CookieConsentService.getCookieSettings();
        settings.didConsentToAllManually = false;
        settings.didConsentToEssentialManually = true;
        settings.didConsentImplicitly = true;
        settings.shouldShowCookieBanner = false;
        settings.shouldShowImpliedCookieBanner = false;

        CookieConsentService.saveCookieConsent(settings);
    },
    onHideImpliedConsentBanner: function () {
        var settings = CookieConsentService.getCookieSettings();
        settings.didConsentImplicitly = true;
        settings.shouldShowImpliedCookieBanner = false;

        CookieConsentService.saveCookieConsent(settings);
    },
    onRevokeConsent: function () {
        confirm("Checkout cannot work without cookies.</br>Are you sure you want to revoke your cookie consent?",
            function (didConfirm) {
                if (didConfirm) {
                    var settings = CookieConsentService.getCookieSettings();
                    settings.didConsentToAllManually = false;
                    settings.didConsentImplicitly = false;
                    settings.shouldShowCookieBanner = true;
                    settings.shouldShowImpliedCookieBanner = true;

                    CookieConsentService.saveCookieConsent(settings);
                }
            },
            "Cookie consent",
            "REVOKE CONSENT",
            "CANCEL");
    },
    saveCookieConsent: function (consentSettings) {
        if (this.CookieConsentKey === "") {
            //console.log("Cookie consent key was not set");
            return;
        }

        var settingsJson = JSON.stringify(consentSettings);

        //Checking if settings changed
        //If changed, cookie will be set and page reloaded
        var consentCookie = getCookie(this.CookieConsentKey);
        if (settingsJson !== consentCookie) {
            setCookie(this.CookieConsentKey, settingsJson, 730);
        }
    },
    showConsentModal: function () {
        var message = "This feature is not available without cookie consent." +
            "<a href='/en/cookie-policy' class='btn btn-link' style='padding-top:0;'>Learn more</a>";
        var title = "Consent to cookies";

        confirm(message, function (didNotConsent) {
            //We're inversing button names and hence meaning so that Consent is shown as blue (ie: safe option)
            if (!didNotConsent) {
                CookieConsentService.onManuallyConsentToAllCookies();
            }
        },
            title,
            "CLOSE",
            "ACCEPT &amp; CLOSE",
            //Hiding close button for express consent
            //Putting back close button will also need extra work since 
            //close and 'Consent to cookies' will have same meaning
            false);
    }
};

//Cookie consent bindings

//Preventing redirect

function ConsentBinding(event) {
    //TODO: improve on design so that instead of refresh we redirect to basket/account login
    if (!CookieConsentService.didConsentToAllCookies()) {
        //Preventing redirect
        event.preventDefault();

        CookieConsentService.showConsentModal();
    }
}

//document.getElementById("basketLink").addEventListener(ConsentBinding);
//document.getElementById("accountLoginLink").addEventListener(ConsentBinding);

//End - cookie consent bindings
const deleteCookie = (name) => {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
        let [key, value] = el.split('=');
        cookie[key.trim()] = value;
    })
    return cookie[cookieName];
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}



export { CookieConsentService }

